export function toCamelCase(str: string) {
  return str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
}

export function toSnakeCase(str: string) {
  return str.replace(/([A-Z])/g, '_$1').toLowerCase();
}

export function strToLocaleString(dateStr: string) {
  const date = new Date(dateStr);
  return date.toLocaleString();
}

export function isNotEmptyElement(element: any) {
  if (element === null || typeof element === 'undefined') {
    return false;
  }

  if (Array.isArray(element) && element.length === 0) {
    return false;
  }

  return true;
}

interface JqueryPopover extends JQuery {
  popover?: ({}) => any;
}

export function renderJqueryPopover(popoverClassName: string) {
  const jqueryPopover: JqueryPopover = $(popoverClassName);

  if (jqueryPopover.length > 0 && typeof jqueryPopover.popover === 'function') {
    jqueryPopover.popover({
      container: 'body',
      html: true,
      trigger: 'hover | focus',
      placement: 'auto',
    });
  }
}
